module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie a NavBar is the top parent container for Nessie NavList, Nessie NavItem, Nessie NavDropdown they should be use together if your aim is to create a Nessie navigation bar.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;NavBar&gt;\n    &lt;NavItem isCurrentPage&gt;Home&lt;/NavItem&gt;\n    &lt;NavItem&gt;Somewhere else&lt;/NavItem&gt;\n&lt;/NavBar&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/NavBar/README.md
// module id = 364
// module chunks = 0